import { type FC, useCallback, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import GenericDetailPageLayout from "../core/navigation-panel/GenericDetailPageLayout.js";
import { type IRouteNavItemProps } from "../core/navigation-panel/RouteNavItem.js";
import MarkerSummaryView from "./MarkerSummaryView.js";
import { type IMarkerState, loadMarker } from "@/redux/modules/marker.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { type ReduxDispatch } from "@/redux/redux-utils.ts";
import { ENTITY_TYPE } from "@/settings/settings.js";

const MarkerDetailPage: FC = () => {
  // redux
  const dispatch = useDispatch<ReduxDispatch>();
  const { marker, isLoading } = useSelector<IAppState, IMarkerState>((state) => state.marker, shallowEqual);

  // router
  const { markerId } = useParams<"markerId">();

  useEffect(() => {
    dispatch(loadMarker(Number(markerId)));
  }, [dispatch, markerId]);

  const getNavItems = useCallback((): IRouteNavItemProps[] => {
    return [
      {
        label: "Summary",
        route: "summary",
        pageComponent: <MarkerSummaryView />,
        default: true,
      },
    ];
  }, []);

  return (
    <GenericDetailPageLayout
      groupType={ENTITY_TYPE.MARKER}
      groupSubtypeId={marker?.markerType.id}
      entityId={Number(markerId)}
      getDisplayName={() => marker?.name}
      sidebarNavItems={getNavItems()}
      isLoading={isLoading}
    />
  );
};

export { MarkerDetailPage };
